import SupportEmailAddress from './SupportEmailAddress';

export default SupportEmailAddress;
